import './DimensionalValuesTable.css';

import React from 'react';
import B2BTable from '../../../b2b-common/B2BTable';
import { generateClassName } from '../../../b2b-common/helpers';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const DimensionalValuesTable = ({ dimensionalValues, dimensionalType, objectiveType, measurementUnit = '', onSelectedDimension, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');

    if ((!dimensionalType) || (!dimensionalValues)) {
        return null;
    }

    const headers_regular = [
        { label: t('Dimension'), align: 'left' },
        { label: t('Start Value'), align: 'center' },
        { label: t('End Value'), align: 'center' },
    ];
    const headers_threshold = [
        { label: t('Dimension'), align: 'left' },
        { label: t('Threshold Value'), align: 'center' },
    ];
    const headers_range = [
        { label: t('Dimension'), align: 'left' },
        { label: t('Lower Range'), align: 'center' },
        { label: t('Higher Range'), align: 'center' },
    ];

    // Create a dictionary for dimension values
    // const dimensionValueDict = dimensionalType.dimensionValues.reduce((acc, value) => {
    //     acc[value.dimensionValueOrder] = value.dimensionValueName;
    //     return acc;
    // }, {});

    // Create a dictionary for dimensional values
    const dimensionalValueDict = dimensionalValues.reduce((acc, value) => {
        acc[value.quantitativeDimensionOrder] = value;
        return acc;
    }, {});

    const rows_regular = [
        ...dimensionalType.dimensionValues.map((dimension) => {
            const value = dimensionalValueDict[dimension.dimensionValueOrder] || {};
            return {
                id: dimension.dimensionValueOrder,
                cells: [
                    { content: `D${dimension.dimensionValueOrder} - ${dimension.dimensionValueName}`, align: 'left' },
                    { content: value.startQuantitativeValue !== undefined ? `${value.startQuantitativeValue} ${measurementUnit}` : '-', align: 'right' },
                    { content: value.endQuantitativeValue !== undefined ? `${value.endQuantitativeValue} ${measurementUnit}` : '-', align: 'right' },
                ],
            };
        }),
    ];

    const rows_threshold = [
        ...dimensionalType.dimensionValues.map((dimension) => {
            const value = dimensionalValueDict[dimension.dimensionValueOrder] || {};
            return {
                id: dimension.dimensionValueOrder,
                cells: [
                    { content: `D${dimension.dimensionValueOrder} - ${dimension.dimensionValueName}`, align: 'left' },
                    { content: value.startQuantitativeValue !== undefined ? `${value.startQuantitativeValue} ${measurementUnit}` : '-', align: 'right' },
                ],
            };
        }),
    ];

    const rows_range = [
        ...dimensionalType.dimensionValues.map((dimension) => {
            const value = dimensionalValueDict[dimension.dimensionValueOrder] || {};
            return {
                id: dimension.dimensionValueOrder,
                cells: [
                    { content: `D${dimension.dimensionValueOrder} - ${dimension.dimensionValueName}`, align: 'left' },
                    { content: value.startQuantitativeValue !== undefined ? `${value.startQuantitativeValue} ${measurementUnit}` : '-', align: 'right' },
                    { content: value.endQuantitativeValue !== undefined ? `${value.endQuantitativeValue} ${measurementUnit}` : '-', align: 'right' },
                ],
            };
        }),
    ];

    const headers =
        objectiveType === 'Regular-Dimensional' ? headers_regular :
            (objectiveType === 'Threshold_Above-Dimensional' || objectiveType === 'Threshold_Below-Dimensional') ? headers_threshold :
                headers_range;

    const rows =
        objectiveType === 'Regular-Dimensional' ? rows_regular :
            (objectiveType === 'Threshold_Above-Dimensional' || objectiveType === 'Threshold_Below-Dimensional') ? rows_threshold :
                rows_range;

    const handleRowClick = (row) => {
        if (onSelectedDimension) {
            onSelectedDimension(row.id);
        }
    };

    return (
        <B2BTable
            headers={headers}
            rows={rows}
            className={generateClassName('dimensional-values-table','', className)}
            onRowClick={handleRowClick}
        />
    );
}

export default DimensionalValuesTable;